// extracted by css-extract-rspack-plugin
export default {"file":"file-eghn_n","name":"name-O2JQQ3","hover":"hover-b4Vq7M"};